import { cx } from "@jugl-web/utils";
import { CSSProperties, FC } from "react";
import { priceFormatter } from "../../utils/priceFormatter";
import { ChatButton } from "../ChatButton";

interface ProductCardProps {
  name: string;
  imageUrl: string | null;
  price: number;
  className?: string;
  style?: CSSProperties;
  onSelect?: () => void;
}

export const ProductCard: FC<ProductCardProps> = ({
  name,
  imageUrl,
  price,
  className,
  style,
  onSelect,
}) => {
  return (
    <div
      className={cx(
        "border-dark-200 flex flex-col overflow-hidden rounded-2xl border border-solid bg-white",
        className
      )}
      style={style}
    >
      {imageUrl !== null && (
        <div className="h-[150px] w-full shrink-0 overflow-hidden border border-r-0 border-t-0 border-l-0 border-solid border-[#F2F2F2]">
          <img
            src={imageUrl}
            alt={name}
            className="h-full w-full object-cover"
          />
        </div>
      )}
      <div className="flex flex-col gap-1.5 px-3 py-4">
        <span
          className="font-secondary text-dark whitespace-normal text-sm font-medium leading-[150%]"
          style={{
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: 2,
            overflow: "hidden",
          }}
          title={name}
        >
          {name}
        </span>
        <span className="font-secondary text-dark text-base font-semibold leading-[140%]">
          {priceFormatter.format(price)}
        </span>
      </div>
      {!!onSelect && (
        <>
          <div className="flex-1" />
          <div className="px-3 pt-3 pb-4">
            <ChatButton variant="primary" fullWidth onClick={onSelect}>
              Select
            </ChatButton>
          </div>
        </>
      )}
    </div>
  );
};
